import { UserTokens } from '@/features/membership/shared/types/token.types';

export async function fetchMembershipTokens(): Promise<UserTokens> {
  const response = await fetch('/api/membership/tokens', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error(`Could not fetch member token ${response.status}`);
  }
  return (await response.json()) as UserTokens;
}

const TTL_MS = 5 * 60 * 1000; // 5 minutes
let cache: UserTokens | null = null;
let expiresAt = 0;
let inflight: Promise<UserTokens> | null = null;

export async function fetchMembershipTokensCached(forceRefresh = false): Promise<UserTokens> {
  const now = Date.now();
  const isValid = !forceRefresh && cache && expiresAt > now;

  if (isValid) {
    return cache!;
  }

  if (inflight) {
    return inflight;
  }

  inflight = (async () => {
    try {
      const tokens = await fetchMembershipTokens();
      cache = tokens;
      expiresAt = Date.now() + TTL_MS;
      return tokens;
    } catch (err) {
      console.error('Failed to fetch member tokens (cached):', err);
      throw err;
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}

export function bustMembershipTokensCache() {
  cache = null;
  expiresAt = 0;
}
